import React, { useEffect, useState } from 'react';
import { Modal, Button, Card } from 'react-bootstrap';
import './QuizzBtn.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import CustomCard from './CustomCard';
import axiosInstance from '../configurations/axiosInstance/AxiosInstance';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faJournalWhills, faListCheck } from '@fortawesome/free-solid-svg-icons';

const QuizzBtn = () => {
  const [showModal, setShowModal] = useState(false);

  const [quizz, setQuizz] = useState(null);

    const fetchQuizz = ()=>{
        axiosInstance().get('public/api/sondage/anonyme')
            .then(function (response) {
                let data = response.data;
                if(data.length===0){
                    setQuizz(null);
                }else {
                    setQuizz(data);
                }
            })
            .catch(function (error) {
                setQuizz(null);
            });

    }
    useEffect(
        ()=>{
            fetchQuizz();
        },[]
    )

  const quizzes = [
    {
        id: 1,
        title: "Transport Maritime",
        description: "Testez vos connaissances sur le transport maritime",
        duration: "10 minutes",
        questions: 15,
        difficulty: "Intermédiaire"
      },
      {
        id: 2,
        title: "Douanes et Réglementations",
        description: "Questions sur les procédures douanières",
        duration: "15 minutes",
        questions: 20,
        difficulty: "Avancé"
      },
      {
        id: 3,
        title: "Logistique Internationale",
        description: "Les bases de la logistique internationale",
        duration: "8 minutes",
        questions: 10,
        difficulty: "Débutant"
      },
      {
        id: 4,
        title: "Transport Maritime",
        description: "Testez vos connaissances sur le transport maritime",
        duration: "10 minutes",
        questions: 15,
        difficulty: "Intermédiaire"
      },
      {
        id: 5,
        title: "Douanes et Réglementations",
        description: "Questions sur les procédures douanières",
        duration: "15 minutes",
        questions: 20,
        difficulty: "Avancé"
      },
      {
        id: 6,
        title: "Logistique Internationale",
        description: "Les bases de la logistique internationale",
        duration: "8 minutes",
        questions: 10,
        difficulty: "Débutant"
      }
  ];

  return (
    <>
    {quizz != null && <>
      <button 
        className="quizz-floating-btn" 
        onClick={() => setShowModal(true)}
      >
        <FontAwesomeIcon icon={faListCheck} className='px-2'/>
        <span> Sondages</span> 
      </button>

      <Modal 
        show={showModal} 
        onHide={() => setShowModal(false)}
        size="lg"
        className="quizz-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Sondages Disponibles</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="quizz-grid">
            {quizz.map(quiz => (
              <CustomCard 
                key={quiz.id} 
                name={quiz.name} 
                createUser={quiz.createUser}
                questions={quiz.questions.length}
                id={quiz.id} />
            ))}
          </div>
        </Modal.Body>
      </Modal>
    </>}
    </>
    
  );
};

export default QuizzBtn;